import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms"
import { Permissions } from "../../../../access/shared/authorization/permissions"
import { Client } from "../../../shared/client/client"
import { Group } from "./group"
import { RoleHierarchy } from "./role-hierarchi"
import { User } from "./user"

export function minElementValidator(countNb: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const hasEnough = control.value instanceof Array && control.value.length > countNb
        return hasEnough ? null : { 'minElement': { value: control.value } }
    }
}

export class UserForm extends FormGroup {

    constructor() {
        super({
            'civility': new FormControl("1", [
                Validators.required
            ]),
            'username': new FormControl("", [
                Validators.required
            ]),
            'is_anett': new FormControl(false, [
                Validators.required
            ]),
            'is_agent_distri': new FormControl(false, [
                Validators.required
            ]),
            'is_admin_distri': new FormControl(false, [
                Validators.required
            ]),
            'is_admin_site': new FormControl(false, [
                Validators.required
            ]),
            'firstname': new FormControl("", [
            ]),
            'lastname': new FormControl("", [
            ]),
            'email': new FormControl("", [
                Validators.email,
                Validators.required
            ]),
            'phone': new FormControl("", [

            ]),
            'enabled': new FormControl(true, [
                Validators.required
            ]),
            'site_affectation': new FormControl(undefined, [
            ]),
            'roles': new FormControl(new Array<RoleHierarchy>(), [
                minElementValidator(0)
            ]),
            'clients': new FormControl(new Array<RoleHierarchy>(), [
                //minElementValidator(0)
            ]),
        })
    }

    removeClients() {
        this.get("clients").setValue(new Array<Group>())
    }

    filterPredicate(client: Client, filter: string): boolean {
        return this.get('clients').value == null || !this.get('clients').value.some((c: Client, index: number, arr: Client[]): boolean => {
            return c.id === client.id
        }) && client != null && (client.code_client + " " + client.code_service + " " + client.raison_sociale).toUpperCase().includes(filter.trim().toUpperCase())
    }

    isAdminSite(): boolean {
        return this.get('is_admin_site').value === true
    }

    isSelectedRole(role: RoleHierarchy): boolean {
        return this.get('roles').value.some(r => this.equalsRole(role, r))
    }

    getRoles() {
        return this.get('roles').value.filter(v => {
            return Object.values(Permissions).includes(v.name)
        });
    }

    isAnett(): boolean {
        return this.get("is_anett").value == true
    }

    isAgentDistri(): boolean {
        return this.get("is_agent_distri").value == true
    }

    equalsRole(r: RoleHierarchy, or: RoleHierarchy): boolean {
        return r.id === or.id
    }

    updateRoles(role: RoleHierarchy) {
        let currentValues: Array<RoleHierarchy> = this.get('roles').value
        if (this.isSelectedRole(role)) {
            currentValues = currentValues.filter(r => !this.equalsRole(role, r))
        } else {
            currentValues.push(role)
        }
        this.get('roles').setValue(currentValues)
    }

    selectGroup(client: Client) {
        if (!this.get('clients').value.includes(client)) {
            this.get('clients').setValue(this.get('clients').value.concat(new Array<Client>(client)))
        }
    }

    unselectGroup(client: Client) {
        this.get('clients').setValue(this.get('clients').value.filter(curr => client != curr))
    }

    public updateClientsControl() {

        let validators = [
            minElementValidator(0)
        ]
        if (this.isAnett() == true || this.isAgentDistri() == true) {
            validators = []
        }
        this.get('clients').setValidators(validators)
        this.get('clients').clearValidators()
    }

    patchValue(user: User) {
        super.patchValue({
            'civility': user.civility,
            'username': user.username,
            'is_anett': user.is_anett,
            'firstname': user.firstname,
            'lastname': user.lastname,
            'email': user.email,
            'phone': user.phone,
            'enabled': user.enabled,
            'roles': user.roles != undefined ? user.roles : new Array<RoleHierarchy>(),
            'clients': user.clients != undefined ? user.clients : new Array<Group>(),
            'site_affectation': user.site_affectation,
            'is_admin_site': user.is_admin_site,
            'is_agent_distri': user.is_agent_distri,
            'is_admin_distri': user.site_affectation != null ? user.site_affectation.numero == '0' : false
        })
    }

}
